/*! gsap.runningMouse.js | v1.0.2 | license Copyright (C) 2022 - 2023 Taichi Matsutaka */
/*
 *
 * @name    : gsap.runningMouse.js
 * @content : runningMouse
 * @url     : https://github.com/taichaaan/js-gsap-runningMouse
 * @creation: 2022.04.05
 * @update  : 2023.12.03
 * @version : 1.0.2
 *
 * @useLibrary : gsap.js
 *
 */
(function(global) {[]
	global.runningMouse = function(target,options){
		///////////////////////////////////////////////////////////////
		// defaults options
		///////////////////////////////////////////////////////////////
		this.targetElements = Array.prototype.slice.call( document.querySelectorAll( target ) ,0) ;

		const defaults = {
			runningTargetSelector: '.js-runningMouse__cell',
			reactionRange        : 30,
			moveSize             : 5,
			speed                : 0.5,
			ease                 : 'power2.out',
			getDefaultEvent      : ['load','resize'],
		}


		///////////////////////////////////////////////////////////////
		// options
		///////////////////////////////////////////////////////////////
		for( let option in options){
			defaults[option] = options[option];
		}
		this.options = defaults;


		///////////////////////////////////////////////////////////////
		// base
		///////////////////////////////////////////////////////////////
		this.removes = [];
		this.base();


	};
	runningMouse.prototype = {
		base: function(){
			const _this   = this;
			const options = this.options;




			///////////////////////////////////////////////////////////////
			// forEach
			///////////////////////////////////////////////////////////////
			this.targetElements.forEach(function(target) {
				///////////////////////////////////////////////////////////////
				// variable
				///////////////////////////////////////////////////////////////
				const runningTarget = target.querySelectorAll( options['runningTargetSelector'] );
				const defaultXs = [];
				const defaultYs = [];

				let pageX = 0;
				let pageY = 0;


				///////////////////////////////////////////////////////////////
				// getDefault
				///////////////////////////////////////////////////////////////
				const getDefault = function(){
					const sy = document.documentElement.scrollTop || document.body.scrollTop;

					for ( let i = 0; i < runningTarget.length; i++ ) {
						const width  = runningTarget[i].clientWidth;
						const height = runningTarget[i].clientHeight;
						const rect   = runningTarget[i].getBoundingClientRect();
						const top    = rect.top + sy;
						const left   = rect.left;

						defaultXs[i] = left + width * 0.5;
						defaultYs[i] = top + height * 0.5;
					}
				};
				for ( let i = 0; i < options['getDefaultEvent'].length; i++ ) {
					window.addEventListener( options['getDefaultEvent'][i] ,getDefault);

					/* ---------- removes ---------- */
					_this.removes.push( function(){
						window.removeEventListener( options['getDefaultEvent'][i] ,getDefault);
					});
				}



				///////////////////////////////////////////////////////////////
				// onMousemove
				///////////////////////////////////////////////////////////////
				const onMousemove = function(){
					pageX = event.pageX;
					pageY = event.pageY;

					for ( let i = 0; i < runningTarget.length; i++ ) {
						let mx = defaultXs[i];
						let my = defaultYs[i];

						/* ---------- 計算 ---------- */
						const angle = Math.atan2(my - pageY, mx - pageX);

						const d = Math.sqrt(Math.pow((mx - pageX),2) + Math.pow((my - pageY),2));
						mx += Math.cos(angle) * options['reactionRange'] * Math.pow(0.975,d);
						my += Math.sin(angle) * options['reactionRange'] * Math.pow(0.975,d);

						const distant = Math.sqrt(Math.pow((mx - defaultXs[i]),2) + Math.pow((my - defaultYs[i]),2));
						mx -= (mx - defaultXs[i]) * distant * 0.01;
						my -= (my - defaultYs[i]) * distant * 0.01;

						const x = (mx - defaultXs[i]) * options['moveSize'];
						const y = (my - defaultYs[i]) * options['moveSize'];

						gsap.to( runningTarget[i] , {
							x: x,
							y: y,
							duration: options['speed'],
							ease    : options['ease'],
						});
					}
				}
				target.addEventListener('mousemove',onMousemove);

				/* ---------- removes ---------- */
				_this.removes.push( function(){
					target.removeEventListener('mousemove',onMousemove);
				});

			});
		},
		remove: function(){
			/* removes に追加された関数をforで一つずつ実行する。 */
			const removes = this.removes;

			if( !removes ) return;

			for ( let i = 0; i < removes.length; i++ ) {
				removes[i]();
			}
		},
	};

})(this);
